import { download, listPages } from './console/api.ts';
import { InputError } from './console/errors.ts';
import { type Actions, current, render } from './console/router.ts';
import { $, act } from './console/ui.ts';
import { go } from './views/avisos.ts';
import { statsQuery } from './views/estadisticas.ts';
import { currentPolicyQuery } from './views/polizas.ts';

/**
 * The buttons every screen shares, answered like a view's: «Reintentar» on a screen that failed
 * to load, a report in Excel or PDF, «Cargar más» of a list, and a link to another screen.
 */
export const actions: Actions = {
  click: {
    retry: () => void render(),
    report: (t, d) => {
      if (!d.report || !d.format) return;
      const report = d.report;
      const format = d.format;
      void act(t, 'Generando el reporte…', async () => {
        // Collections from «Pólizas y recibos» (its months); the policies with the list's own
        // search and filters (#310); the rest with the statistics' filters.
        const query = new URLSearchParams(
          (report === 'policies' ? currentPolicyQuery() : statsQuery()).slice(1),
        );
        if (report === 'collections') {
          const from = ($('#rep-from') as HTMLInputElement | null)?.value ?? '';
          const to = ($('#rep-to') as HTMLInputElement | null)?.value ?? '';
          if (!from || !to) throw new InputError('Elige los meses del reporte.');
          query.set('from', from < to ? from : to);
          query.set('to', from < to ? to : from);
        }
        query.set('format', format);
        const name = await download(
          `/v1/reports/${encodeURIComponent(report)}?${query}`,
          `reporte.${format}`,
        );
        return `«${name}» descargado.`;
      });
    },
    more: (t, d) => {
      if (!d.more) return;
      // One page more of that list; the button keeps the focus (or the list, on its last page).
      const list = d.more;
      listPages[list] = (listPages[list] ?? 1) + 1;
      t.setAttribute('aria-busy', 'true');
      void render(current, { quiet: true }).then(() =>
        ($(`[data-more="${list}"]`) ?? $('#main')).focus({ preventScroll: true }),
      );
    },
    go: (_, d) => {
      if (d.go) void go(d.go);
    },
  },
};
